import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Lightning, ArrowRight } from "@phosphor-icons/react";
import { toast, Toaster } from "sonner";

const BG = "https://static.prod-images.emergentagent.com/jobs/0d3d3cfe-8955-4d30-9e66-8fa3e173a9be/images/d8a3031a097b49a89d0c565aae09bd0d0ed1a14cb75736349997324f4c6dde93.png";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@painelbot.com");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (user && user !== false) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) {
      toast.success("Bem-vindo de volta!");
      nav("/");
    } else {
      toast.error(res.error || "Falha no login");
    }
  };

  return (
    <div
      className="min-h-screen relative flex items-center justify-center px-4"
      style={{
        backgroundImage: `url('${BG}')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0 bg-white/40" />
      <Toaster position="top-center" richColors />
      <div
        data-testid="login-card"
        className="relative z-10 w-full max-w-md glass-card p-10"
      >
        <div className="flex items-center gap-2 mb-8">
          <div className="h-9 w-9 bg-[#002FA7] text-white flex items-center justify-center">
            <Lightning weight="fill" size={20} />
          </div>
          <div>
            <div className="font-display font-black text-[15px] tracking-tight leading-none">
              PAINEL.BOT
            </div>
            <div className="label-mono mt-1">Control Room</div>
          </div>
        </div>

        <h1 className="font-display font-black text-4xl tracking-tight text-[#0F172A] leading-[1.05]">
          Bem-vindo
          <br />
          de volta.
        </h1>
        <p className="text-sm text-[#64748B] mt-3 leading-relaxed">
          Acesse o painel para gerenciar testes gratuitos enviados via WhatsApp.
        </p>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label className="label-mono block mb-2">E-mail</label>
            <input
              data-testid="login-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-white border border-[#E5E7EB] px-3 py-2.5 text-sm rounded-sm focus:outline-none focus:ring-2 focus:ring-[#002FA7] focus:border-[#002FA7]"
              placeholder="admin@painelbot.com"
            />
          </div>
          <div>
            <label className="label-mono block mb-2">Senha</label>
            <input
              data-testid="login-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-white border border-[#E5E7EB] px-3 py-2.5 text-sm rounded-sm focus:outline-none focus:ring-2 focus:ring-[#002FA7] focus:border-[#002FA7]"
              placeholder="••••••••"
            />
          </div>
          <button
            data-testid="login-submit-btn"
            type="submit"
            disabled={submitting}
            className="group w-full bg-[#002FA7] text-white text-sm font-medium tracking-tight py-3 rounded-sm hover:bg-[#001f7a] transition-colors duration-150 flex items-center justify-center gap-2 disabled:opacity-50"
          >
            {submitting ? "Entrando..." : "Entrar"}
            <ArrowRight size={16} weight="bold" className="transition-transform duration-150 group-hover:translate-x-0.5" />
          </button>
        </form>

        <div className="mt-8 pt-6 border-t border-[#E5E7EB]">
          <div className="label-mono mb-2">Credenciais padrão</div>
          <div className="text-xs text-[#64748B] mono">
            admin@painelbot.com / admin123
          </div>
        </div>
      </div>
    </div>
  );
}
